const complexValidator = (first, second) => value =>
  (first && first(value)) || (second && second(value));

export default complexValidator;
